(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
		var main = new Splide( '.js-thumb-splide', {
			rewind : true,
			arrows : false,
			pagination : false,
			focus    : 'center',
			type     : 'loop',
		} ).mount();

		var thumbnails = new Splide( '.js-thumb-items', {
			arrows : false,
			rewind      : true,
			pagination  : false,
			isNavigation: true,
			autoWidth: true,
		} ).mount();

		main.sync( thumbnails );


  });
})();
